import React, { PureComponent } from 'react';
import { filter } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { del as delPartner, get as getPartner } from '../../redux/modules/partners';
import ListEntity from '../../components/ListEntity/List';
import Partner from '../../components/ListEntity/Entities/Partner';
import LayoutSection from '../../components/layout-section';
import Modal from '../../components/Render/Modal/Modal';
import PartnerForm from '../../forms/partner/index';

class General extends PureComponent {
  state = { isOpen: false };

  getData() {
    this.props.getAction();
  }

  componentWillMount() {
    this.getData()
  }

  remove(info) {
    if (info.id > 0) {
      const { getAction, delAction } = this.props;
      delAction(info.id).then(() => {
        getAction();
      });
    }
  }

  toggleOpenModal(data = {}) {
    this.setState({ isOpen: !this.state.isOpen, data });
  }

  render() {
    const { partners } = this.props;
    return (
      <div className="contacts-container container">
        <LayoutSection
          isFetching={partners.isFetching}
          title="Partners">
          <ListEntity
            number={6}
            component={Partner}
            removeAction={(index) => {
              this.remove(partners.values[index])
            }}
            editAction={(index) => {
              this.toggleOpenModal(partners.values[index]);
            }}
            addAction={() => {
              this.toggleOpenModal();
            }}
            values={partners.values}/>
        </LayoutSection>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenModal.bind(this)}
            isOpen={this.state.isOpen}>
            <PartnerForm
              defaultValues={this.state.data}
              close={this.toggleOpenModal.bind(this)}
              contactType={this.state.contactType}/>
          </Modal>
        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      partners: state.partners
    };
  },
  (dispatch) => {
    return bindActionCreators({ getAction: getPartner, delAction: delPartner }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/general/index.js